export default __webpack_public_path__ + "static/media/az.be1f909b.svg";